import _ from 'lodash';
import Vue from 'vue';
import {MutationTree} from 'vuex';
import TimeZoneService from '../services/timeZoneService';
import {ConnectionStatus} from '../enums';
import EcCommon from '../../../types/ec/ecCommon';
import EcMemberSearch from '../../../types/ec/ecMemberSearch';
import LtFramework from '../../../types/lt/ltFramework';

export const AlertNotificationMutations: MutationTree<LtFramework.IAlertNotificationState> = {
	setAlertNotifications(state: LtFramework.IAlertNotificationState, payload: LtFramework.IAlertNotification[]) {
		state.alertNotifications = payload;
	},
};

export const ClubLocationsMutations: MutationTree<EcCommon.IClubLocationsState> = {
	setCountries(state: EcCommon.IClubLocationsState, payload: EcCommon.ICountry[]) {
		state.countries = payload;
	},
	setClub(state: EcCommon.IClubLocationsState, payload: EcCommon.IMultiSelectGroupOptions) {
		_.forEach(state.countries, (country) => {
			_.forEach(country.StateProvinces, (stateProvince) => {
				_.forEach(stateProvince.Clubs, (club) => {
					if (club.ClubId === payload.Value) {
						Vue.set(club, 'Selected', payload.IsSelected);
						if (payload.IsSelected) {
							state.selectedClubs.push(club);
						} else {
							const index = _.findIndex(state.selectedClubs, { ClubId: club.ClubId});
							state.selectedClubs.splice(index, 1);
						}
					}
				});
			});
		});
	},
	removeClub(state: EcCommon.IClubLocationsState, payload: EcCommon.IClub) {
		const country = _.find(state.countries, { Name: payload.Country });
		if (country) {
			const stateProvince = _.find(country.StateProvinces, { Name: payload.StateProvince});
			if (stateProvince) {
				const club = _.find(stateProvince.Clubs, ({ ClubId: payload.ClubId}));
				if (club) {
					Vue.set(club, 'Selected', payload.Selected);
					const index = _.findIndex(state.selectedClubs, { ClubId: club.ClubId});
					state.selectedClubs.splice(index, 1);
				}
			}
		}
	},
	unSelectAllClubs(state: EcCommon.IClubLocationsState) {
		state.selectedClubs.splice(0, state.selectedClubs.length);
		_.forEach(state.countries, (country) => {
			_.forEach(country.StateProvinces, (stateProvince) => {
				_.forEach(stateProvince.Clubs, (club) => {
					Vue.set(club, 'Selected', false);
				});
			});
		});
	},
};

export const EmployeeProfileMutations: MutationTree<LtFramework.IEmployeeProfileState> = {
	setEmployeeProfile(state: LtFramework.IEmployeeProfileState, payload: LtFramework.IEmployeeProfile) {
		state.employeeProfile = payload;
	},
};

export const MemberSearchMutations: MutationTree<EcMemberSearch.IState> = {
	setTrainerDetails(state: EcMemberSearch.IState, payload: EcCommon.ITrainerDetails) {
		Vue.set(state.members[payload.index], 'coachFirstName', payload.firstName);
		Vue.set(state.members[payload.index], 'coachLastName', payload.lastName);
		Vue.set(state.members[payload.index], 'coachPartyId', payload.partyId);
	},
	setMembers(state: EcMemberSearch.IState, payload: EcMemberSearch.IMember[]) {
		if (payload) {
			_.forEach(payload, (member) => {
				Vue.set(member, 'photo', '/content/dam/employee/images/profile_blank.svg');
				Vue.set(member, 'dateOfBirth', TimeZoneService.convertToLocal(member.dateOfBirth, member.timeZone));
				Vue.set(member, 'connectionStatus', ConnectionStatus.NotConnected);
				Vue.set(member, 'inValidEmailAddress', false);
			});
			state.members = payload;
		} else {
			state.members = [];
		}
	},
	resetMembers(state: EcMemberSearch.IState) {
		state.members.splice(0, state.members.length);
	},
	setMemberPhoto(state: EcMemberSearch.IState, payload: EcMemberSearch.IsearchMemberPhoto[]) {
		_.forEach(payload, (memberPhoto) => {
			const member = _.find(state.members, (m) => {
				return m.memberId === memberPhoto.memberId;
			});

			if (member) {
				Vue.set(member, 'photo', memberPhoto.photo ? memberPhoto.photo : '/content/dam/employee/images/profile_blank.svg');
				Vue.set(member, 'photoLoaded', true);
			}
		});
	},
	setConnectStatus(state: EcMemberSearch.IState) {
		_.forEach(state.members, (member) => {
			if (member.sourceId && member.sourceType && member.coachPartyId > 0) {
				Vue.set(member, 'connectionStatus', ConnectionStatus.Connected);
			}
		});
	},
	setEmailAddressInvalid(state: EcMemberSearch.IState, payload: number) {
		const member = _.find(state.members, (m) => {
			return m.partyId === payload;
		});

		if (member && !member.inValidEmailAddress) {
			Vue.set(member, 'inValidEmailAddress', true);
		}
	},
	updateConnectionStatus(state: EcMemberSearch.IState, payload: EcMemberSearch.IStatusPayload) {
		const member = _.find(state.members, (m) => {
			return m.memberId === payload.member.memberId;
		});

		if (member) {
			Vue.set(member, 'connectionStatus', payload.connectionStatus);
		}
	},
};

export const ProfileMutations: MutationTree<LtFramework.IProfileState> = {
	setProfile(state: LtFramework.IProfileState, payload: LtFramework.IProfile) {
		state.profile = payload;
	},
};

export const UrlMutations: MutationTree<LtFramework.IUrlState> = {
	setUrl(state: LtFramework.IUrlState, payload: LtFramework.IUrl) {
		state.url = payload;
	},
};
